module.exports = __webpack_public_path__ + "static/media/icon-delete-white.5bc4f934.svg";